export default __webpack_public_path__ + "static/media/MoveFacilityCardIcon.d3d93ddb.svg";